// src/utils/ProtectedRoute.js
import React, { useContext, useState, useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const ProtectedRoute = () => {
  const { user, isAuthenticated, loading, hasPagePermission } = useContext(AuthContext);
  const location = useLocation();
  const currentPath = location.pathname;
  const [permissionLoading, setPermissionLoading] = useState(true);
  const [hasPermission, setHasPermission] = useState(false);
  
  // Check permission in useEffect to avoid state updates during render
  useEffect(() => {
    if (isAuthenticated && user && !loading) {
      setPermissionLoading(true);
      const permission = hasPagePermission(currentPath);
      setHasPermission(permission);
      setPermissionLoading(false);
    }
  }, [isAuthenticated, user, loading, currentPath, hasPagePermission]);
  
  // Show loading spinner while auth state is being determined
  if (loading || permissionLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }
  
  // Redirect to login if not authenticated
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ from: location }} />;
  }
  
  // Redirect to unauthorized page if no permission
  if (!hasPermission) {
    return <Navigate to="/unauthorized" state={{ from: location }} />;
  }
  
  // If authenticated and authorized, render the outlet
  return <Outlet />;
};

export default ProtectedRoute;